const State = cc.Enum({
    IDLE: 'idle',
    PROGRESS: 'progress',
});

const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        label: cc.Label
    },

    ctor () {
        this.promises = [];
        this.score = 0;
    },

    /**
     * Set a number
     * @param score
     */
    setNumber (score) {
        const scoreString = i18n.formatCurrencySmall(score);

        this.label.string = scoreString;
    },

    /**
     *
     * Start counter animation of the score. Emit an event 'checkpoint' with the data of the checkpoint index,
     * after each threshold
     * @param progressTime
     * @param score
     * @param checkPoints
     * @returns {Promise}
     */
    startProgress (progressTime, scoreTo, scoreFrom = 0, checkPoints = []) {
        return new Promise((resolve) => {
            this.cleanup();

            this.score = scoreFrom;
            this.targetScore = scoreTo;
            let checkpointIndex = 0;

            this.state = State.PROGRESS;
            this.progressTween = cc.tween(this).to(progressTime, { score: scoreTo }, {
                progress: (start, end, current, ratio) => {
                    const  currentScore = (end - start) * ratio + start;

                    if (this.isProgressFinished) {
                        this._onProgressComplete();
                        resolve();
                        return;
                    }
                    if (checkPoints[checkpointIndex] && currentScore > checkPoints[checkpointIndex]) {
                        this.node.emit('checkpoint', { checkpoint: checkpointIndex + 1 });
                        checkpointIndex++;
                    }

                    this.setNumber(currentScore);
                }
                // easing: 'sineIn'
            }).call(() => {
                this._onProgressComplete();
                resolve();
            }).start();
        });
    },

    _onProgressComplete () {
        this.isProgressFinished = false;
        this.progressTween.stop();
        this.progressTween = null;
        this.setNumber(this.targetScore);
        this.state = State.IDLE;
        this.node.emit('progressFinish');
    },

    finishProgress () {
        if (this.state !== State.PROGRESS) {
            return;
        }
        this.isProgressFinished = true;
    },

    cleanup () {
        this.finishProgress();
        this.unscheduleAllCallbacks();
    },
});